module.exports = __webpack_public_path__ + "static/media/book.8dfef633.png";